/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosNetflowEcosysChainRequest = {
    period?: AptosNetflowEcosysChainRequest.period;
};

export namespace AptosNetflowEcosysChainRequest {

    export enum period {
        H24 = 'H24',
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        Y1 = 'Y1',
        YTD = 'YTD',
    }


}

